export default "__VITE_ASSET__Bu0v1i4z__"